export const hasStatusCode = (err: Error): err is Error & { statusCode: number } => {
	return 'statusCode' in err && typeof err.statusCode === 'number';
};

export const isServerSideResponse = (errorCode: number | null | undefined): boolean =>
	!!errorCode && errorCode >= 500 && errorCode < 600;
